import Vue from 'vue'
import Vuex from 'vuex'
import settings from './store/settings'
import theme from './store/theme'
import auth from './store/auth'

import media from './store/media'
import profile from './store/profile'

import tag from './store/tag'
import article from './store/article'
import articleTable from './store/articleTable'
import tabs from './store/tabs'

import operations from './store/operations'
import replacements from './store/replacements'
import accessories from './store/accessories'
import sims from './store/sims'

import riparazioni_bytewood from './store/riparazioni_bytewood'
import riparazioni_clienti from './store/riparazioni_clienti'

import usato_clienti from './store/usato_clienti'

import cellulari from './store/gestionale/cellulari'
import sim from './store/gestionale/sim'
import accessori from './store/gestionale/accessori'
import ricambi from './store/gestionale/ricambi'
import servizi from './store/gestionale/servizi'
import formazione from './store/gestionale/formazione'

import preordiniDevices from './store/gestionale/preordini/devices'

import note from './store/note'

import movimenti from './store/movimenti'
import categorie from './store/categorie'

// Filtri
import filtriStoricoVendite from './store/filtri/storicoVendite'
import filtriMovimenti from './store/filtri/movimenti'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    settings,
    theme,
    auth,

    media,
    profile,

    tag,
    article,
    articleTable,
    tabs,

    operations,
    replacements,
    accessories,
    sims,

    riparazioni_bytewood,
    riparazioni_clienti,
    
    usato_clienti,

    cellulari,
    sim,
    accessori,
    ricambi,
    servizi,
    formazione,

    preordiniDevices,

    note,

    movimenti,
    categorie,

    filtriStoricoVendite,
    filtriMovimenti
  }
})